var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-campaign-overview',{staticClass:"minimal-critical-height",attrs:{"customer-id":_vm.customerId},on:{"rowclicked":(e) => _vm.rowClicked(e),"create":function($event){return _vm.create()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }